<template>
  <div class="question-box">
    <div class="question-title">
      <div v-html="questionContent.content"></div>
      <viewer :images="questionContent.file" class="question-title-imgbox" v-if="questionContent.file && questionContent.file.length">
        <img v-for="(src,index) in questionContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <el-input type="textarea" :rows="5" v-model="shortAnswer" placeholder="请输入答案"></el-input>
  </div>
</template>

<script>
import { userSubmitTopicData } from '@/api/show'
export default {
  created() {

  },
  beforeDestroy() {
    if (!this.status) {
      this.answerPost();
    }
  },
  watch: {
    currentIndex: function () {
      this.initData()
    }
  },
  props: ['itemContent', 'index', 'currentIndex', 'status', 'recordId', 'replay_type'],
  data() {
    return {
      shortAnswer: '',
      titleId: '',//试题id
      optionsContent: [],
      questionContent: {},//题干数据保存
      analysisContent: {},//解析数据保存

    }
  },
  mounted() {
    this.initData()
    let answer = sessionStorage.getItem('answer')
    if (answer !== '' && answer !== 'undefined') {
      answer = JSON.parse(answer)
      this.shortAnswer = answer
    }
    window.onbeforeunload = e => {
      if (this.$route.fullPath === "/show/exercise") {
        e = e || window.event;
        if (e) {
          e.returnValue = "关闭提示";
        }
        // return "关闭提示";
      } else {
        window.onbeforeunload = null
      }
    };
  },
  methods: {
    initData: function () {
      this.shortAnswer = ''
      this.titleId = this.itemContent.id
      this.optionsContent = this.itemContent.answer
      this.questionContent = this.itemContent.topic_title
      this.analysisContent = this.itemContent.parsing
    },
    //提交答案
    answerPost: function () {
      let flag = true
      // if(this.shortAnswer===''){
      // 	flag = false
      // }
      if (flag) {
        let info = JSON.parse(sessionStorage.getItem('paperInfo'))
        let params = {
          student_id: info.studentId,
          competition_id: info.competitionId,
          paper_id: info.paperId,
          title_id: this.titleId,
          title_type: 8,
          answer: this.shortAnswer,
          record_id: this.recordId,
          replay_type: this.replay_type
        }
        userSubmitTopicData(params).then(response => {
          let obj = {
            type: 'short',
            index: this.index,
            currentIndex: this.currentIndex,
            answer: this.shortAnswer
          }
          this.$root.$emit('returnanswer', obj);
        })
      }

    }
  },
}
</script>

<style scoped="">
</style>